"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardHeader = exports.TEST_ID_CARD_HEADER = void 0;
var theme_ui_1 = require("theme-ui");
exports.TEST_ID_CARD_HEADER = "CardHeader";
var CardHeader = function (_a) {
    var header = _a.header, subHeader = _a.subHeader;
    return (theme_ui_1.jsx(theme_ui_1.Flex, { sx: {
            flexDirection: "column",
            alignItems: "flex-start",
        } },
        theme_ui_1.jsx(theme_ui_1.Heading, { as: "small", variant: "text.small" }, header),
        subHeader && (theme_ui_1.jsx(theme_ui_1.Heading, { as: "h2", variant: "text.h4" }, subHeader))));
};
exports.CardHeader = CardHeader;
